
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import mixin from "./mixin";
import notifications from "../../../lib/notifications";
import * as modals from "@/lib/modals";

const orderModule = getModule(OrderModule);

@Component({
  name: modals.messageCustomerModal
})
export default class MessageCustomerModal extends Mixins(mixin) {
  emailAddresses: Array<any> = [];
  phoneNumbers: Array<any> = [];
  loading: boolean = false;
  emailSubject: string = null;
  emailBody: string = null;
  sending: boolean = false;
  textBody: string = null;
  includeDocuments: boolean = false;
  includeDocumentIds: Array<string> = [];

  get orderNumber() {
    return this.selectedItems[0].number;
  }

  async load() {
    this.show();

    if (this.selectedItems && this.selectedItems.length > 1) {
      this.includeDocumentIds = this.selectedItems[1];
    } else {
      this.includeDocumentIds = [];
    }
    this.includeDocuments = this.selectedItems && this.selectedItems.length > 1;

    this.loading = true;
    try {
      let emailSettingsResponse = await orderModule.getEmailCustomerSettingsForOrder(
        this.orderNumber
      );
      this.emailAddresses = emailSettingsResponse.data.map(x => ({
        emailAddress: x.emailAddress,
        send: true
      }));
    } catch (ex) {
      notifications.error("Email Settings", "Failed to load email settings for customer", ex);
    }
    try {
      let textSettingsResponse = await orderModule.getTextCustomerSettingsForOrder(
        this.orderNumber
      );
      this.phoneNumbers = textSettingsResponse.data.map(x => ({
        textNumber: x.textNumber,
        send: true
      }));
    } catch (ex) {
      notifications.error("Text Settings", "Failed to load text settings for customer", ex);
    }
    this.loading = false;
    if (this.emailAddresses && this.emailAddresses.length === 0)
      this.emailAddresses.push({ emailAddress: "", send: true });
    if (this.phoneNumbers.length === 0) this.phoneNumbers.push({ textNumber: "", send: true });
  }

  async sendText() {
    let phoneNumbersToSend = this.phoneNumbers
      .filter(x => x.send && x.textNumber != "")
      .map(x => x.textNumber);

    if (phoneNumbersToSend.length < 1) {
      notifications.error(
        "Order Text Not Sent",
        "Please select or enter at least one phone number."
      );
      return;
    }

    this.sending = true;
    let payload = {
      textNumber: phoneNumbersToSend[0],
      textMessage: this.textBody,
      orderNumber: this.orderNumber
    };

    try {
      await orderModule.sendConsigneeText(payload);
      notifications.success("Order Text Sent", "Text successfully sent.");
      this.hideModal();
    } catch (ex) {
      notifications.error("Order Text Not Sent", "Text failed to send.", ex);
    }
    this.sending = false;
  }

  async sendEmail() {
    let emailAddressesToSend = this.emailAddresses
      .filter(x => x.send && x.emailAddress != "")
      .map(x => x.emailAddress);
    if (emailAddressesToSend.length < 1) {
      notifications.error(
        "Order Email Not Sent",
        "Please select or enter at least one email address."
      );
      return;
    }

    this.sending = true;
    let payload = {
      emailAddresses: emailAddressesToSend,
      subject: this.emailSubject,
      body: this.emailBody,
      orderNumber: this.orderNumber,
      includeDocuments: this.includeDocuments,
      documentIds: this.includeDocumentIds
    };

    try {
      await orderModule.sendConsigneeEmail(payload);
      notifications.success("Order Email Sent", "Email successfully sent.");
      this.hideModal();
    } catch (ex) {
      notifications.error("Order Email Not Sent", "Email failed to send.", ex);
    }
    this.sending = false;
  }

  reset() {
    this.emailAddresses = null;
    this.emailSubject = null;
    this.emailBody = null;
    this.textBody = null;
    this.phoneNumbers = null;
  }

  selectAllEmailAddresses(selected) {
    this.emailAddresses.forEach(element => {
      element.send = selected;
    });
  }

  selectAllPhoneNumbers(selected) {
    this.phoneNumbers.forEach(element => {
      element.send = selected;
    });
  }

  attachLabel() {
    if (this.includeDocumentIds.length === 0) return "Attach all images/documents";
    if (this.includeDocumentIds.length === 1) return "Attach 1 page of images/documents";
    return `Attach ${this.includeDocumentIds.length} pages of images/documents`;
  }
}
